module.exports = __webpack_public_path__ + "img/trophy.41e966df.gif";